import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { filter, Observable } from 'rxjs';
import { DialogYesNoComponent } from './dialog-yes-no.component';
import { ConfirmDialogModel } from './dialog-yes-no.model';

@Injectable({ providedIn: 'root' })
export class DialogYesNoService {
  private dialog = inject(MatDialog);

  open(data: ConfirmDialogModel, filtered = true, width = '400px'): Observable<boolean> {
    const afterClosed$ = this.dialog.open(DialogYesNoComponent, { data, width }).afterClosed();
    return filtered ? afterClosed$.pipe(filter(ok => ok)) : afterClosed$;
  }
}
